import { render, staticRenderFns } from "./PositionsComponent.vue?vue&type=template&id=286b24ca&scoped=true"
import script from "./PositionsComponent.vue?vue&type=script&lang=js"
export * from "./PositionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b24ca",
  null
  
)

export default component.exports